module.exports = __webpack_public_path__ + "8d76854094247c5aa937ad1d1c2814a4.jpg";